// extracted by mini-css-extract-plugin
export default {"tagList":"webpack-pages-StudyList-StudyListItem-StudyTags-module__tagList","tagIcon":"webpack-pages-StudyList-StudyListItem-StudyTags-module__tagIcon"};